import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import App from './App.vue'

import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from './plugins/axios'
// import { refreshAxiosInstance } from './plugins/axios'
import { VueHeadMixin } from '@unhead/vue'
import { createHead } from '@unhead/vue/client'
import { VueMarkdownItPlugin } from '@f3ve/vue-markdown-it';

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import 'tachyons-spacing/css/tachyons-spacing.min.css'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

const head = createHead()
app.mixin(VueHeadMixin)

function routeAllowed (to, store) {
  const target = to.matched.at(-1)

  if (target.meta?.auth === true && !store.getters['auth/isLoggedIn']) {
    // User is not logged in
    return false
  }

  if (target.meta?.gate && !target.meta.gate(to)) {
    // User does not fullfill permission criteria
    return false
  }

  // All criteria met for this route
  return true
}

function routeUser (to, store) {
  if (!routeAllowed(to, store)) {
    if (!store.getters['auth/isLoggedIn']) {
      store.commit('ui/SET_403', false)
      return ({ name: 'LoginPage', query: { from: to.path }})
    } else {
      store.commit('ui/SET_403', true)
      return true
    }
  } else {
    store.commit('ui/SET_403', false)
    return true
  }
}

router.beforeEach((to, from, next) => {
  store.commit('ui/SET_403', false)
  // Erase title so if a page does not specify the page title
  // it doesn't get reused from the previous route
  store.dispatch ('ui/setPageTitle', undefined)

  // Check if we aren't fetching the user data right now
  if (store.getters['auth/refresh_token_call']) {
    // If so, check when it's done!
    store.getters['auth/refresh_token_call'].finally(() => {
      next (routeUser (to, store))
    })
  } else {
    // No relevant API call in progress, we can route the user right away
    next (routeUser (to, store))
  }
})

app
  .use (ElementPlus)
  .use (router)
  .use (store)
  .use (VueAxios, axios)
  .use (head)
  .use (VueMarkdownItPlugin)

// Change default $notify props:
const originalNotify = app.config.globalProperties.$notify
app.config.globalProperties.$notify = (options = {}, context) => originalNotify ( options = {type: 'primary', position: 'top-right', customClass: 'bordered-notification', duration: 15000, ...options }, context )

// Add helper function to print dates
const prettyDateString = function (date) {
  if (date === undefined || date === null) {
    return 'N/A'
  }

  if (!(date instanceof Date)) {
    date = new Date(date)
  }

  return `${date.getFullYear()}/${(date.getMonth()+1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`
}

const prettyDatetimeString = function (date) {
  if (date === undefined || date === null) {
    return 'N/A'
  }

  if (!(date instanceof Date)) {
    date = new Date(date)
  }

  date.setUTCDate (date.getDate())
  date.setUTCHours (date.getHours())

  return `${date.getFullYear()}/${(date.getMonth()+1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
}

app.config.globalProperties.$date = prettyDateString
app.config.globalProperties.$datetime = prettyDatetimeString

app.config.globalProperties.$appName = process.env.VUE_APP_NAME
  
app.mount('#app')